export default __webpack_public_path__ + "static/media/rdl_logo_notext.6e27a5cc.svg";